module.exports = __webpack_public_path__ + "img/menu_mens_tenteki.0cf5730a.png";